module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Ys8NL3/media/FC-9781685620578.jpg?1708093998642",
      "alt": "This image is the cover for the book Reconsidering Medicine"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Reconsidering Medicine\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("This is an original book on the philosophy of medicine. It considers philosophy of medicine as a subdiscipline of philosophy of science. This volume is grounded on an epistemological bottom-up account that arises from the clinical situation, the epidemiologic, and the resulting public health account. It is not a review of the literature, and it is not intended to frame the debates, or to analyze and compare the various number of viewpoints.")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("Medicine is the human activity, which begins by a linguistic act that identifies the negative norms of health: it begins with a first distinction that splits biological processes into three conventional parts, normal, abnormal and pathologic. Neither of them is a natural kind. Being abnormal is intrinsically bad and admits of degrees, while being pathologic is dichotomous. Being normal is factitious and counterfactual much the same as frictionless planes in physics. Leaving apart the ethical aspects, this book endeavors to uncover the implicit conceptual network, the chief junctures of medicine, should they be found, and their articulations with clinical and community medicine. It results that medicine is pervaded with dichotomous concepts such as scientific vs pragmatic discourse, function and malfunction, abnormal and pathologic, needs and wants, causation and explanation, clinical vs community-oriented care, physical vs psychiatric diseases, mental illness vs deviancy, and so on. Medical thinking has two dimensions intrinsically interweaved, namely a constant amalgam and admixture of biological and normative aspects, so that this essential hybrid nature of the grammar of medicine endorses opposite approaches, naturalistic or normativist, biological or value-laden, realist or instrumental, reductionist or holistic, phenomenological or analytic.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Lucien Karhausen\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Born in Brussels. Graduated in medicine from Brussels Free"), _c('br'), _vm._v("University in 1952.")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Internship in medicine in Brussels 1952–1956")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Training in internal medicine at Memorial Hospital, Cornell Medical School 1956–1960")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Training in epidemiology, at Memorial Hospital, Cornell Medical School, 1960–1961")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Master’s degree in hygiene, Harvard School of Public Health, 1961–1962")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Assistant professor in epidemiology, Faculty of Médicine, Brussels Free University, 1962–1964")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("European Commission official, 1964–1985")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v("Invited professor, Rome University La Sapienza, 1988–1990")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "16px",
      "font-family": "\"Times New Roman\",serif",
      "text-align": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "15px"
    }
  }, [_vm._v(" ")])]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Austin Macauley Publishers\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0